import styled, { css } from 'styled-components';
import { breakpoint, color, font } from 'styles/globals';
import { getBodyStyle, getColor, Theme } from 'styles/theme';
import { arrowLeft } from 'styles/icons';

export const Wrapper = styled.div`
    .latest-popular-module {
        padding: 0 16px;
    }
`;

export const ContentWrapper = styled.div<{ theme: Theme }>`
    ${getBodyStyle('georgia', { default: 'default' })};
    
    color: #111;
    line-height: 1.5em;
    margin: 0 auto 48px;
    max-width: 740px;
    padding: 0 20px;

    @media (${breakpoint.lgMin}) {
        margin-bottom: 68px;
    }

    @media (${breakpoint.xlMin}) {
        max-width: 700px;
        padding: 0;
    }
`;

const arrow = css<{ theme: Theme }>`
  padding: 4.5px;
  border-color: ${getColor('iconPrimary')};
  margin-bottom: 1px;
  border-width: 0 2px 2px 0;

  &:hover,
  &:focus {
    border-color: ${getColor('iconAccentPrimary')};
  }
  &:active {
    border-color: ${getColor('iconSecondary')};
  }
`;

export const PreviousArrow = styled.span<{ theme: Theme }>`
    ${arrowLeft};
    ${arrow};
    border-color: currentColor;
`;

export const Header = styled.div`
    background-color: ${color.shadeBrandPrimary50};
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: ${font.saolText};
    margin: 0 -24px;
    padding: 40px 48px 68px;
    text-align: center;
    
    .back-link {
        align-self: flex-start;
        align-items: center;
        color: ${color.accentPrimary};
        display: flex;
        font-family: ${font.graphikCond};
        margin-bottom: 32px;
        gap: 8px;
        
        a {
            color: inherit;
        }
    }
    
    .header-line {
        font-size: 48px;
        font-weight: 600;
        line-height: 57.6px;
    }
`;

export const TopGroup = styled.div`
    display: flex;
    flex-direction: column-reverse;


    @media (${breakpoint.mdMin}) {
        flex-direction: column;
    }
`;

export const Intro = styled.aside`
    font-family: ${font.graphikCompact};
    margin-bottom: 40px;

    .link {
        color: ${color.accentPrimary};
    }
    
    strong {
        display: block;
        font-weight: 600;
    }
`;

export const ParticipantsHeader = styled.h3`
    border-left: 4px solid ${color.accentSecondary};
    font-family: ${font.graphikCond};
    font-size: 24px;
    font-weight: 600;
    line-height: 28.8px;
    margin-bottom: 24px;
    padding-left: 12px;
`;

export const Participants = styled.ul`
    font-family: ${font.graphikCompact};
    margin-bottom: 48px;
    
    @media (${breakpoint.mdMin}) {
        margin-bottom: 40px;
    }
    
    strong {
        font-weight: 600;
    }
`;

export const SpeakerText = styled.p`
    margin-top: 24px;
    
    + div {
        margin-bottom: 40px;
        margin-top: 40px;
    }
    
    &.new-speaker {
        margin-top: 40px;
    }

    &.with-ad {
        margin-bottom: 24px;
    }
    
    &:first-child {
        margin-top: 0;
    }
`;

export const Author = styled.strong`
    display: block;
    font-size: 20px;
    line-height: 1.5em;
    margin-bottom: 24px;
`;

export const ShareContainer = styled.div`
    display: flex;
    justify-content: space-between;
    letter-spacing: 0.5px;
    line-height: 21px;
    margin-bottom: 24px;
    margin-top: 24px;

    @media (${breakpoint.mdMin}) {
        margin-bottom: 60px;
        margin-top: 48px;
    }

    @media (${breakpoint.xlMin}) {
        margin-top: 64px;
    }
`;

export const QuartrContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
`;

export const MobileShareContainer = styled.div`
  display: block;

  @media (${breakpoint.mdMin}) {
    display: none;
  }
`;

export const DesktopShareContainer = styled.div<{ theme: Theme }>`
  display: none;

  @media (${breakpoint.mdMin}) {
    display: flex;
    flex-direction: row;
    ul{
      display: inline-flex;
      flex-direction: row;
      width: fit-content;
      height: 40px;
      gap: 16px;
      border: 1px solid ${getColor('surfaceSecondary')};
      border-radius: 4px;
      padding: 8px;
    }
  }
`;

export const TrinityPlayerContainer = styled.div`
    margin-bottom: 48px;

    @media (${breakpoint.mdMin}) {
        margin-bottom: 68px;
    }
`;

export const Footer = styled.div`
    margin: 48px 0;
`;
